export default __webpack_public_path__ + "static/GhostBtnStates-20c585f9971cd3f15fc3031d0391f26c.png";